export default {

    methods: {
      
        cleanFn () {
            this.companyId = "";
        },

        getName (title) {
            const titles = [
                { key: "leaks", value: "Leaks", color: "#e3a295", image: require("@/assets/img/loki/indicators/vazamento1.png") },
                { key: "vips", value: "VIPS", color: "#ecc125", image: require("@/assets/img/loki/indicators/vip1.png" )},
                { key: "string", value: "String", color: "#9fbf82", image: require("@/assets/img/loki/indicators/string1.png")},
                { key: "domain", value: "Domain", color: "#939fd5", image: require("@/assets/img/loki/indicators/dominio1.png") },
                { key: "takedowns", value: "Takedowns", color: "#93c4d3", image: require("@/assets/img/loki/indicators/takedown1.png") },
                { key: "findings", value: "Findings", color: "#b49473", image: require("@/assets/img/loki/indicators/finding1.png") },

            ];
            const filterT = titles.filter((ft) => ft.key === title);
            return filterT[0];
        },

        setFilter (step, { event, origin }) {
            switch (step) {
                case "search":
                    this.filter.search = event;
                    break;
                case "page":
                    this.filter.page = event;
                    break;
                case "size":
                    this.filter.size = event;
                    break;
            }
            this.reset(origin)
        },
        submitForm (event) {
            if (event.origin === "domain") {
                this.createDomain(event);
            }
            if (event.origin === 'string') {
                this.createString(event)
            }
            if( event.origin === 'vips'){
                this.createVip(event)
            }
        },
        editForm (event) {
            if (event.route === "domain") {
                this.updateDomain(event);
            }
            if (event.route === 'string') {
                this.updateString(event)
            }
            if( event.route === 'vips'){
                this.updateVip(event)
            }
        },

        reset (origin) {
            
            if (origin === "domain") {
                this.getDomain();
            }
            if (origin === 'string') {
                this.getString()
            }
            if(origin === 'vip'){
                this.getVips()
            }
        },
        remove (event) {
            if (event.route === "domain") {
                this.removeDomain(event);
            }
            if (event.route === "string"){
                this.removeString(event)
            }
            if(event.route === 'vips'){
                this.removeVip(event)
            }
        },
    }
}